export interface ITagRequest {
  contentId: number
  contentType: number
  tags: Array<string>
}
export enum TaggingBehavior {
  Disabled = 0,
  Off = 1,
  On = 2,
}
